import { render, staticRenderFns } from "./laborCost.vue?vue&type=template&id=d1c8c634&scoped=true&"
import script from "./laborCost.vue?vue&type=script&lang=js&"
export * from "./laborCost.vue?vue&type=script&lang=js&"
import style0 from "./laborCost.vue?vue&type=style&index=0&id=d1c8c634&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c8c634",
  null
  
)

export default component.exports